import styled from 'styled-components'

/*
  Gestão WhatsApp. Segue a identidade da área de banking (cartões tingidos, âmbar só como
  acento, conteúdo alinhado à esquerda). As conversas imitam o WhatsApp no essencial: lista à
  esquerda, conversa à direita, mensagens do salão à direita em verde-claro.
*/

const CARD_SHADOW = '0px 2px 10px -6px #252525'
const SURFACE = '#F8F8F7'
const LINE = '#E9E9E6'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const PageTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #252525;
  margin: 14px 0px 10px;
`

export const TabStickyContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #FFFFFF;
  padding: 0px 40px;
  position: sticky;
  top: 0px;
  z-index: 3;
`

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 16px 40px 66px;
`

export const Content = styled.div`
  width: 100%;
  /* Conversas ocupam a tela toda (como o WhatsApp Web); as outras abas ficam numa coluna */
  max-width: ${({ $size }) => ({ full: 'none', wide: '1100px' })[$size] ?? '720px'};
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${SURFACE};
  border: 1px solid ${LINE};
  box-shadow: ${CARD_SHADOW};
  border-radius: 15px;
  padding: 16px;
  gap: ${({ $gap }) => $gap ?? 12}px;
`

export const CardTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #252525;
  margin: 0px;
`

export const Caption = styled.p`
  font-size: 13px;
  color: #808080;
  margin: 0px;
  line-height: 1.45;
  white-space: pre-line;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ $gap }) => $gap ?? 10}px;
  justify-content: ${({ $justify }) => $justify ?? 'flex-start'};
`

export const StatusDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: ${({ $color }) => $color};
`

export const Warning = styled.div`
  border-radius: 12px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  color: #7A4A00;
  background-color: #FFF4DB;
  border: 1px solid #FFD98A;
`

export const ErrorText = styled.p`
  color: #FF3939;
  font-size: 13px;
  margin: 0px;
`

export const QrImage = styled.img`
  width: 240px;
  height: 240px;
  align-self: center;
  border-radius: 12px;
  background-color: #FFFFFF;
  padding: 8px;
`

export const TermsBox = styled.label`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  line-height: 1.45;
  color: #252525;
  cursor: pointer;

  input {
    margin-top: 3px;
    accent-color: #FF9800;
  }
`

/* Chave liga/desliga, um `<button role="switch">` de verdade. */
export const Switch = styled.button`
  width: 46px;
  height: 26px;
  border: none;
  border-radius: 13px;
  padding: 3px;
  cursor: pointer;
  display: flex;
  justify-content: ${({ $on }) => ($on ? 'flex-end' : 'flex-start')};
  background: ${({ $on }) => ($on ? 'linear-gradient(to right, #FFC100, #FF9800)' : '#D6D6D3')};
  transition: background 0.2s;

  &::after {
    content: '';
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #FFFFFF;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.25);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid #252525;
    outline-offset: 2px;
  }
`

/* Conversas */

/*
  Altura fixa e linha única de altura fixa (`minmax(0, 1fr)`): sem isso a coluna da conversa
  cresce com o histórico, a página rola inteira e o cabeçalho e a caixa de mensagem saem da tela.
*/
export const ChatLayout = styled.div`
  width: 100%;
  height: calc(100vh - ${({ $offset }) => $offset ?? 220}px);
  min-height: 420px;
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  border: 1px solid ${LINE};
  border-radius: 15px;
  overflow: hidden;
  box-shadow: ${CARD_SHADOW};
  background-color: #FFFFFF;
`

export const ChatList = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0px;
  border-right: 1px solid ${LINE};
  overflow-y: auto;
  background-color: ${SURFACE};
`

export const ChatItem = styled.button`
  width: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: left;
  border: none;
  border-bottom: 1px solid ${LINE};
  padding: 11px 14px;
  cursor: pointer;
  font: inherit;
  background-color: ${({ $selected }) => ($selected ? '#FFF4DB' : 'transparent')};

  &:hover {
    background-color: ${({ $selected }) => ($selected ? '#FFF4DB' : '#F0F0EE')};
  }
`

export const ChatName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #252525;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ChatPreview = styled.span`
  min-width: 0px;
  flex: ${({ $grow }) => ($grow ? 1 : '0 0 auto')};
  font-size: 12px;
  color: #808080;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ModeBadge = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: #FFFFFF;
  border-radius: 8px;
  padding: 1px 7px;
  background-color: ${({ $color }) => $color};
`

export const ChatPanel = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0px;
  min-height: 0px;
  overflow: hidden;
  background-color: #EFEAE2;
`

export const ChatHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 14px;
  background-color: ${SURFACE};
  border-bottom: 1px solid ${LINE};
`

export const ModeButton = styled.button`
  border: 1px solid ${({ $selected, $color }) => ($selected ? $color : '#D6D6D3')};
  background-color: ${({ $selected, $color }) => ($selected ? $color : '#FFFFFF')};
  color: ${({ $selected }) => ($selected ? '#FFFFFF' : '#252525')};
  border-radius: 10px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const Messages = styled.div`
  flex: 1;
  min-height: 0px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 18px;
`

export const Bubble = styled.div`
  max-width: 70%;
  align-self: ${({ $mine }) => ($mine ? 'flex-end' : 'flex-start')};
  background-color: ${({ $mine }) => ($mine ? '#D9FDD3' : '#FFFFFF')};
  border-radius: 10px;
  padding: 7px 10px 4px;
  font-size: 14px;
  line-height: 1.4;
  color: #111111;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.08);
  white-space: pre-wrap;
  word-break: break-word;

  small {
    display: block;
    text-align: right;
    font-size: 10px;
    color: #808080;
    margin-top: 2px;
  }
`

export const Composer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
  padding: 10px 14px;
  background-color: ${SURFACE};
  border-top: 1px solid ${LINE};
`

export const TextArea = styled.textarea`
  flex: 1;
  resize: none;
  border: 1px solid ${LINE};
  border-radius: 12px;
  padding: 9px 12px;
  font: inherit;
  font-size: 14px;
  min-height: 40px;
  max-height: 140px;
  background-color: #FFFFFF;

  &:focus {
    outline: 2px solid #FFC100;
  }
`

export const EmptyPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 30px;
  color: #808080;
  font-size: 14px;
`

/* Jeito de atender */

export const StyleLayout = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0px, 1fr) 340px;
  gap: 18px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 13px;
  font-weight: 600;
  color: #252525;

  input[type='text'] {
    border: 1px solid ${LINE};
    border-radius: 12px;
    padding: 9px 12px;
    font: inherit;
    font-weight: 400;
    background-color: #FFFFFF;
  }
`

export const Hint = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #808080;
`

export const LinkButton = styled.button`
  border: none;
  background: none;
  padding: 0px;
  font: inherit;
  font-size: 12px;
  color: #FF9800;
  cursor: pointer;
  text-decoration: underline;
`

export const Phone = styled.div`
  position: sticky;
  top: 70px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border-radius: 20px;
  background-color: #EFEAE2;
  border: 6px solid #252525;
`

export const SyncBanner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  color: #1F4D2B;
  background-color: #E7F8EC;
  border: 1px solid #A8E2B9;

  /* O ícone traz "margin: auto" no próprio SVG, que empurrava o texto para a direita */
  svg {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    margin: 0px !important;
  }
`

export const ModeLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #252525;
`
